import React from 'react';


export default class Treinos extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;

    return(
      <div>
        <strong>Por que tenho mais vezes treino de tronco na planilha de 5 e 6 x na semana?</strong><br /><br />
        A ciência mostra que o ideal de descanso muscular para treinos de ER (Exercícios Resistidos=Musculação ) é de aproximadamente 72h a 96h de descanso - Isso significa treinar cada grupamento 2 x por semana.<br /><br />
        Por isso, quando criei a Metodologia do Foco90, calculei Todos os treinos... eu disse todos, quer você escolha hipertrofia ou emagrecimento; quer você treine 3, 4, 5 ou 6 X por semana, você terá sempre 2 treinos semanais para cada grupamento e sempre um intervalo de 72h ate 96 de descanso pra cada grupamento.<br /><br />
        Se você treina 5 x na semana, terça e quarta o tronco está dividido, e na sexta está completo. Por isso, dá impressão de 3 dias de tronco. Mas de fato são 2 treinos para cada musculatura. O resultado nada tem a ver com a qualidade de dias que se treina (menos é mais). Quando a pessoinha quer treino de pernas 3x na semana ainda não treinou o foco90 corretamente, pois as técnicas de falha, cadência e multiarticulares deixam esgotado a musculatura, inviabilizando essa possibilidade.<br /><br />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/Treinos.js